import Vue from "vue";
import {
  Button,
  NavBar,
  Icon,
  CountDown,
  Dialog,
  Col,
  Row,
  Image as VanImage,
  Field,
  NumberKeyboard,
  PasswordInput,
  Toast,
  NoticeBar,
  Form,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Popup,
  Picker,
  Swipe,
  SwipeItem,
  Loading
} from "vant";

import VueQRCodeComponent from "vue-qrcode-component";
import Page from "./layout/Page.vue";
Vue.component("Page", Page);
Vue.component("qr-code", VueQRCodeComponent);

Vue.use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(NavBar);
Vue.use(Loading);
Vue.use(Icon);
Vue.use(CountDown);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);
Vue.use(Field);
Vue.use(NumberKeyboard);
Vue.use(Toast);
Vue.use(NoticeBar);
Vue.use(Form);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(PasswordInput);
